//
//
//
//
//
//



export default {
    props: ['options', 'tab'],
    components: {
      },
    methods: {
      playerReady(player) {
        try {
          player.tech_.vhs.xhr.beforeRequest = function (options) {
            return options
          }
        } catch(e){}
      }
    }
}
